(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fw-picture-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fw-picture-navigation')) {
  customElements.define('fw-picture-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.desktop = this.dataset.fwMode === 'desktop';
      this.setAttribute('data-fw-ready', '');
      this.addEventListener('click', event => {
        const back = event.target.closest('[data-fw-back]');
        const summary = event.target.closest('summary');
        if (back) {
          const detail = back.closest('details');
          detail.open = false;
          detail.querySelectorAll('details[open]').forEach(d => { d.open = false; });
          detail.querySelector('summary').focus({preventScroll:true});
          this.fit();
        } else if (summary && this.contains(summary)) {
          const detail = summary.parentElement;
          if (!detail.open) this.activate(detail);
          else { detail.open = false; this.fit(); }
          event.preventDefault();
          if (!this.desktop && detail.open) detail.querySelector('[data-fw-back]')?.focus({preventScroll:true});
        }
      });
      this.addEventListener('pointerover', event => {
        const summary = event.target.closest('summary');
        if (!summary || summary.contains(event.relatedTarget) || event.pointerType !== 'mouse' || !this.desktop || !matchMedia('(min-width:1200px) and (hover:hover)').matches) return;
        clearTimeout(this.hoverTimer);
        this.hoverTimer = setTimeout(() => this.activate(summary.parentElement), Number(this.dataset.hoverDelay) || 300);
      });
      this.addEventListener('pointerout', event => {
        const summary = event.target.closest('summary');
        if (summary && !summary.contains(event.relatedTarget)) clearTimeout(this.hoverTimer);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const detail = event.target.closest('details');
        if (!detail || !this.contains(detail)) return;
        event.stopPropagation(); detail.open = false;
        detail.querySelector('summary').focus({preventScroll:true}); this.fit();
      });
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      this.mount();
    }
    disconnectedCallback() { clearTimeout(this.hoverTimer); this.observer?.disconnect(); }
    activate(detail, reset = true) {
      const entering = !detail.open;
      Array.from(detail.parentElement.children).forEach(s => { if (s !== detail && s.tagName === 'DETAILS') s.open = false; });
      detail.open = true;
      if (this.desktop && detail.classList.contains('fw-nav-category') && (entering && reset && this.dataset.resetGroups !== 'false' || !detail.querySelector('.fw-nav-group[open]'))) this.defaultGroup(detail);
      this.fit();
    }
    defaultGroup(category) {
      const groups = Array.from(category.querySelectorAll('.fw-nav-group'));
      const selected = groups.find(g => g.dataset.fwDefault === 'true') || groups[0];
      groups.forEach(g => { g.open = g === selected; });
    }
    mount() {
      this.observer?.disconnect();
      this.replaceChildren();
      document.querySelectorAll('template[data-fw-nav-source]').forEach(template => {
        if (template.dataset.fwMenu === this.dataset.fwSlot) this.append(template.content.cloneNode(true));
      });
      this.querySelectorAll('[id]').forEach(e => e.removeAttribute('id'));
      if (this.desktop) {
        const first = this.querySelector(':scope > .fw-nav-category');
        if (first) this.activate(first);
      }
      this.observer?.observe(this);
      this.querySelectorAll('.fw-nav-cards').forEach(e => this.observer?.observe(e));
      this.fit();
    }
    fit() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        if (!this.desktop || !this.getBoundingClientRect().width) return;
        const category = this.querySelector(':scope > .fw-nav-category[open]');
        const rows = Array.from(this.querySelectorAll(':scope > .fw-nav-category > summary')).reduce((n,s) => n+s.getBoundingClientRect().height,0);
        if (!category) { this.style.minHeight = rows+'px'; return; }
        const groups = category.querySelector('.fw-nav-groups');
        if (groups) {
          const products = groups.querySelector('.fw-nav-group[open] > .fw-nav-products');
          const height = Array.from(groups.querySelectorAll(':scope > .fw-nav-group > summary')).reduce((n,s) => n+s.getBoundingClientRect().height,0);
          groups.style.minHeight = Math.ceil(Math.max(height,products?.getBoundingClientRect().height || 0))+'px';
        }
        this.style.minHeight = Math.ceil(Math.max(rows,category.querySelector('.fw-nav-category-panel').getBoundingClientRect().height))+'px';
      });
    }
  });
  const refresh = () => document.querySelectorAll('fw-picture-navigation').forEach(nav => nav.mount());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',refresh); else refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:reorder',refresh);
  document.addEventListener('shopify:section:unload',event => {
    const id = event.detail.sectionId;
    document.querySelectorAll('[data-fw-source]').forEach(node => { if (node.dataset.fwSource === id) node.remove(); });
    document.querySelectorAll('fw-picture-navigation').forEach(nav => nav.fit());
  });
  const reveal = event => {
    const desktop = matchMedia('(min-width:1200px)').matches;
    const roots = Array.from(document.querySelectorAll('fw-picture-navigation')).filter(n => n.desktop === desktop);
    let chosen;
    for (const root of roots) {
      chosen = Array.from(root.querySelectorAll(event.type === 'shopify:block:select' ? '[data-fw-block]' : '[data-fw-source]')).find(n => event.type === 'shopify:block:select' ? n.dataset.fwBlock === event.detail.blockId : n.dataset.fwSource === event.detail.sectionId);
      if (!chosen) continue;
      const parents = []; let node = chosen;
      while (node) { if (node.tagName === 'DETAILS') parents.unshift(node); node = node.parentElement; }
      parents.forEach(d => { if (root.contains(d)) root.activate(d,false); else d.open = true; });
      root.fit(); break;
    }
  };
  document.addEventListener('shopify:block:select',reveal);
  document.addEventListener('shopify:section:select',reveal);
}
  } catch(e) { console.error(e); }
})();

})();
